import React from 'react';
import PropsTypes from 'prop-types';
import Box from '@mui/material/Box';

const AppContainerWrapper = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
      }}
    >
      {children}
    </Box>
  );
};

export default AppContainerWrapper;

AppContainerWrapper.propTypes = {
  children: PropsTypes.node,
};
